import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDownload = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M11.5003 13.8L7.35031 9.61998H7.36031C7.16031 9.42998 6.85031 9.41998 6.65031 9.61998C6.46031 9.81998 6.46031 10.13 6.65031 10.33L11.6503 15.37L12.0003 15.73L12.3503 15.37L17.3503 10.33C17.5503 10.13 17.5503 9.80998 17.3503 9.61998C17.2503 9.51998 17.1203 9.46998 17.0003 9.46998C16.8803 9.46998 16.7503 9.51998 16.6503 9.61998L12.5003 13.8V3.5C12.5003 3.22 12.2803 3 12.0003 3C11.7203 3 11.5003 3.22 11.5003 3.5V13.8Z'
      fill=''
    />
    <path
      d='M3.5 16C3.77614 16 4 16.2239 4 16.5V18.5C4 18.7761 4.22386 19 4.5 19H19.5C19.7761 19 20 18.7761 20 18.5V16.5C20 16.2239 20.2239 16 20.5 16C20.7761 16 21 16.2239 21 16.5V18.5C21 19.3284 20.3284 20 19.5 20H4.5C3.67157 20 3 19.3284 3 18.5V16.5C3 16.2239 3.22386 16 3.5 16Z'
      fill=''
    />
  </svg>
);
export default SvgDownload;
